<template>
  <DialogComponent
    v-model="updateFailedDialogOpen"
    max-width="35rem"
    persistent
  >
    <div class="force-update-failed">
      <h2>{{ $t('common.errorOccurred') }}</h2>
      <p>{{ $t('common.error.serverOfflineMessage') }}</p>
      <Btn large block :disabled="!retryEnabled" @click="retry">
        {{ $t('common.tryAgain') }}<span v-if="!retryEnabled"> ({{ retrySecondsLeft }}s)</span>
      </Btn>
    </div>
  </DialogComponent>
</template>

<script setup lang="ts">
import DialogComponent from '@acs/components-library/src/components/common/Dialog.vue';
import Btn from '@acs/components-library/src/components/common/Btn.vue';
import { useForceUpdateGuard } from '../../composables/useForceUpdateGuard';

const { updateFailedDialogOpen, retryEnabled, retrySecondsLeft, retry } = useForceUpdateGuard();
</script>

<style lang="scss" scoped>
.force-update-failed {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: center;
}
</style>
